import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function create(data) {
  const response = await http
    .postData("/asesmen-geriatri", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id, data) {
  const response = await http
    .putData(`/asesmen-geriatri/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/asesmen-geriatri`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/asesmen-geriatri/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function masters() {
  const response = await http
    .getData("/asesmen-geriatri/masters")
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function barthelAwalSource(register_id: string | number) {
  return http.getData(`/register/${register_id}/asesmen-geriatri/barthel-awal`);
}

async function sign(id: number, peran: string, data) {
  const response = await http
    .putData(`/asesmen-geriatri/${id}/sign-${peran}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signDpjp(id: number, data) {
  return sign(id, "dpjp", data);
}

async function signPerawat(id: number, data) {
  return sign(id, "perawat", data);
}

async function signGizi(id: number, data) {
  return sign(id, "gizi", data);
}

async function signKetuaTim(id: number, data) {
  return sign(id, "ketua-tim", data);
}

async function signKonsulan(id: number, data) {
  return sign(id, "konsulan", data);
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/asesmen-geriatri/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

function print(id) {
  window.open(`${http.getAPI()}/asesmen-geriatri/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  find,
  masters,
  barthelAwalSource,
  signDpjp,
  signPerawat,
  signGizi,
  signKetuaTim,
  signKonsulan,
  destroy,
  print
};
